import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { KYMW1300UpdateNextGuideAutoModel } from '../vo/kymw1300-update-next-guide-auto.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　次回案内自動設定するサービス
 *
 * @export UpdateNextGuideAutoService
 * @class UpdateNextGuideAutoService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class UpdateNextGuideAutoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof UpdateNextGuideAutoService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1300UpdateNextGuideAutoModel}
   * @memberof UpdateNextGuideAutoService
   */
  private vo: KYMW1300UpdateNextGuideAutoModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof UpdateNextGuideAutoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateNextGuideAutoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        UpdateNextGuideAuto: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType
          },
          combination: this.vo.pCodeList.map(pCode => {
            return {
              condition: {
                PCodeList: pCode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateNextGuideAutoService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model>model;
    this.vo = <KYMW1300UpdateNextGuideAutoModel>vo;
    this.successFunc = successFunc;
    this.send('updateNextGuideAuto', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateNextGuideAutoService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
